import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';

import MenuItem from './MenuItem';

import {
  ROLE,
  ROUTES_CONSTANTS,
  ROUTES,
  TABS_CONSTANTS_TRANSLATIONS,
  ROUTES_CONSTANTS_TRANSLATIONS_AND_ICONS,
  ROUTES_CONSTANTS_CONFIG,
  TABS_CONSTANTS
} from '../../../const';
import { getClassroomTo } from '../../../utils/routeUtils';

const DEFAULT_BODY_CLASS = 'menu-body';

export class ClassroomOptions extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.bodyClass = DEFAULT_BODY_CLASS;
  }

  static propTypes = {
    classId: PropTypes.string,
    role: PropTypes.string,
    layoutSettings: PropTypes.any,
    isAppOnline: PropTypes.any
  };

  static renderOptionsSeparator() {
    return <i className="menu-options-separator" />;
  }

  getWorkspaceItem() {
    const { classId, layoutSettings, role } = this.props;

    const userSettings =
      role === ROLE.INSTRUCTOR
        ? layoutSettings.teacherSettings
        : role === ROLE.COINSTRUCTOR
        ? layoutSettings.coinstructorSettings
        : layoutSettings.studentSettings;
    const disabledTab = false;
    if (userSettings.classroomSections.homeTabs.length === 1) {
      const hiddenHomeTab = userSettings.classroomSections.homeTabs[0];
      const icon = ROUTES_CONSTANTS_TRANSLATIONS_AND_ICONS[hiddenHomeTab]
        ? ROUTES_CONSTANTS_TRANSLATIONS_AND_ICONS[hiddenHomeTab].icon
        : 'workspace';

      let title = I18n.t(TABS_CONSTANTS_TRANSLATIONS[hiddenHomeTab]);
      if (hiddenHomeTab === TABS_CONSTANTS.STUDENT_ANALYTICS && role === ROLE.STUDENT) {
        title = I18n.t(TABS_CONSTANTS_TRANSLATIONS[TABS_CONSTANTS.MY_PROFILE]);
      }

      return (
        <MenuItem
          key="workspace"
          icon={icon}
          title={title}
          to={`${ROUTES.CLASSROOM}/${classId}`}
          disabledOffline={disabledTab}
        />
      );
    }
    return (
      <MenuItem
        key="workspace"
        icon="workspace"
        title={I18n.t('leftMenu.workspace')}
        to={`${ROUTES.CLASSROOM}/${classId}`}
        disabledOffline={disabledTab}
      />
    );
  }

  renderSettingsItems() {
    const { layoutSettings, role, isAppOnline, classId } = this.props;
    const userSettings =
      role === ROLE.INSTRUCTOR
        ? layoutSettings.teacherSettings
        : role === ROLE.COINSTRUCTOR
        ? layoutSettings.coinstructorSettings
        : layoutSettings.studentSettings;

    return userSettings.classroomSections.menuRoutes.map(routeConstant => {
      switch (routeConstant) {
        case ROUTES_CONSTANTS.CLASSROOM:
          return this.getWorkspaceItem();
        default:
          let disabledTab = false;
          if (!isAppOnline) {
            disabledTab = ROUTES_CONSTANTS_CONFIG[routeConstant].offlineDisabled;
          }
          return (
            <MenuItem
              key={routeConstant}
              icon={ROUTES_CONSTANTS_TRANSLATIONS_AND_ICONS[routeConstant].icon}
              title={I18n.t(ROUTES_CONSTANTS_TRANSLATIONS_AND_ICONS[routeConstant].translation)}
              to={getClassroomTo(classId, routeConstant)}
              disabledOffline={disabledTab}
            />
          );
      }
    });
  }

  render() {
    return (
      <div className={this.bodyClass}>
        {this.renderSettingsItems()}
        {ClassroomOptions.renderOptionsSeparator()}
      </div>
    );
  }
}

export default connect(mapStateToProps)(ClassroomOptions);

function mapStateToProps(state) {
  return {
    i18n: state.i18n,
    role: state.classrooms.selectedClassroom.classroom.role,
    classId: state.classrooms.selectedClassroom.classroom.id,
    layoutSettings: state.theme.layoutSettings,
    isAppOnline: state.connection.status.online
  };
}
